// src/components/Toast.jsx
import { useEffect } from 'react';

export default function Toast({ message, type = 'success', onDone }) {
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(onDone, type === 'error' ? 5000 : 2500);
    return () => clearTimeout(t);
  }, [message, type, onDone]);

  if (!message) return null;
  return <div className={`toast ${type}`}>{message}</div>;
}
